import { Auth } from 'aws-amplify';

async function getToken() {
  const currentSession = await Auth.currentSession();
  const { idToken } = currentSession;
  return idToken.jwtToken;
}
// hack until we get a proper env setup with myq-core
const baseUrl =
  import.meta.env.VITE_ENV === 'dev'
    ? 'https://xpzz7kp9m2.us-east-1.awsapprunner.com/api'
    : 'https://cwb82shc6w.us-east-1.awsapprunner.com/api';

const checkResponseType = async (response) => {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  } else {
    return response.text(); // Fallback to text for non-JSON responses
  }
};
export async function getWizard(orgId) {
  const token = await getToken();
  const response = await fetch(`${baseUrl}/wizard/getWizard`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
    body: JSON.stringify({ orgId }),
  });
  if (!response.ok) {
    throw new Error(`GetWizard HTTP error! status: ${response.status}`);
  }
  return checkResponseType(response);
}
